import { globals } from '../../globals'

// ------------------------------------
// Constants
// ------------------------------------
export const GET_CLIENT_USERS_START = 'GET_CLIENT_USERS_START'
export const CLIENT_USERS_FETCHED = 'CLIENT_USERS_FETCHED'
export const GET_CLIENT_USERS_FAILED = 'GET_CLIENT_USERS_FAILED'
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'
export const CLEAR_USERS = 'CLEAR_USERS'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getClientUsers
}

export function getClientUsers (clientId) {
  return (dispatch) => {
    dispatch({ type: CLEAR_USERS })
    dispatch({ type: GET_CLIENT_USERS_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/user?clientId=${clientId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 404) {
        dispatch({
          type: GET_CLIENT_USERS_FAILED,
          payload: {
            json: [],
          },
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: CLIENT_USERS_FETCHED,
          payload: {
            json,
            users: returnUsers(json)
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_CLIENT_USERS_FAILED })
    })
  }
}

export function updatePermissions (id, item) {
  return {
    type: UPDATE_PERMISSIONS,
    item,
    id
  }
}

export function updateUserData (location, valueType, valueID, fieldValue) {
  return {
    type: UPDATE_USER_DATA,
    location,
    valueType,
    payload: {
      value: valueID,
      fieldValue: fieldValue,
    }
  }
}

function returnUsers (data) {
  let newObjectUsers = {}
  for (let i = 0; i <= data.length - 1; i++) {
    let newSelected = []
    const isActive = data[i].IsActive
    const isAdmin = data[i].IsAdmin
    if (isActive) {
      newSelected = [...newSelected, 'IsActive']
    }
    if (isAdmin) {
      newSelected = [...newSelected, 'IsAdmin']
    }
    newObjectUsers[data[i].UserId] = {
      selected: newSelected,
      textValues: {},
      permissions: {
        selected: []
      }
    }
  }
  newObjectUsers[0] = {
    selected: [],
    textValues: {},
    permissions: {
      selected: []
    }
  }
  return newObjectUsers
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_CLIENT_USERS_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [CLIENT_USERS_FETCHED] : (state, action) => {
    const { json, users } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        clientUsers: json
      },
      formDataValue: {
        ...state.formDataValue,
        clientUsers: users
      }
    }
  },
  [GET_CLIENT_USERS_FAILED] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
      },
    }
  },
  [UPDATE_PERMISSIONS] : (state, action) => {
    const { id } = action
    const itemData = state.renderData.clientUsers.filter(item => item.UserId === parseInt(id))[0]
    const values = itemData.Permissions.map(item => item.PermissionId)
    let resultedArray = state.formDataValue.clientUsers[id].permissions.selected
    for (let i = 0; i < values.length - 1; i++) {
      if (!resultedArray.includes(values[i])) {
        resultedArray = Array.isArray(values[i])
          ? [...resultedArray, ...values[i]]
          : [...resultedArray, values[i]]
      }
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
      },
      formDataValue: {
        ...state.formDataValue,
        clientUsers: {
          ...state.formDataValue.clientUsers,
          [id]: {
            ...state.formDataValue.clientUsers[id],
            permissions: {
              selected: resultedArray
            }
          }
        },
      }
    }
  },
  [CLEAR_USERS] : () => {
    return {
      ...initialState,
    }
  },
  [UPDATE_USER_DATA] : (state, action) => {
    switch (action.valueType) {
      case 'ch': {
        // mark single checkbox as checked
        const { value } = action.payload
        const { id, field } = action.location
        let resultedSelectedArray = []
        if (field === 'clientUsers') {
          resultedSelectedArray = Array.isArray(value)
            ? [...state.formDataValue.clientUsers[id].selected, ...value]
            : [...state.formDataValue.clientUsers[id].selected, value]
          return {
            ...state,
            formDataValue: {
              ...state.formDataValue,
              clientUsers: {
                ...state.formDataValue.clientUsers,
                [id]: {
                  ...state.formDataValue.clientUsers[id],
                  selected: resultedSelectedArray
                }
              },
            }
          }
        } else {
          resultedSelectedArray = Array.isArray(value)
            ? [...state.formDataValue.clientUsers[id][field].selected, ...value]
            : [...state.formDataValue.clientUsers[id][field].selected, value]
          return {
            ...state,
            formDataValue: {
              ...state.formDataValue,
              clientUsers: {
                ...state.formDataValue.clientUsers,
                [id]: {
                  ...state.formDataValue.clientUsers[id],
                  [field]: {
                    selected: resultedSelectedArray
                  }
                }
              },
            }
          }
        }
      }

      case 'ch_uncheck': {
        // uncheck single checkbox
        const { id, field } = action.location
        const { value } = action.payload
        let resultedSelectedArray = field === 'clientUsers'
          ? state.formDataValue.clientUsers[id].selected
          : state.formDataValue.clientUsers[id][field].selected
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            resultedSelectedArray = resultedSelectedArray.filter(function (element) {
              return element !== value[i]
            })
          }
        } else {
          const idIndex = field === 'clientUsers'
            ? state.formDataValue.clientUsers[id].selected.indexOf(value)
            : state.formDataValue.clientUsers[id][field].selected.indexOf(value)
          resultedSelectedArray = [
            ...resultedSelectedArray.slice(0, idIndex),
            ...resultedSelectedArray.slice(idIndex + 1)
          ]
        }
        if (field === 'clientUsers') {
          return {
            ...state,
            formDataValue: {
              ...state.formDataValue,
              clientUsers: {
                ...state.formDataValue.clientUsers,
                [id]: {
                  ...state.formDataValue.clientUsers[id],
                  selected: resultedSelectedArray
                }
              },
            }
          }
        } else {
          return {
            ...state,
            formDataValue: {
              ...state.formDataValue,
              clientUsers: {
                ...state.formDataValue.clientUsers,
                [id]: {
                  ...state.formDataValue.clientUsers[id],
                  [field]: {
                    selected: resultedSelectedArray
                  }
                }
              },
            }
          }
        }
      }

      case 'textinput' : {
        // set text value
        const { id } = action.location
        const { value, fieldValue } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientUsers: {
              ...state.formDataValue.clientUsers,
              [id]: {
                ...state.formDataValue.clientUsers[id],
                textValues: {
                  ...state.formDataValue.clientUsers[id].textValues,
                  [value]: fieldValue,
                }
              }
            }
          }
        }
      }

      case 'checkbox-exclude-others': {
        // exclude all other checkboxes
        const { id } = action.location
        const { value } = action.payload
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientUsers: {
              ...state.formDataValue.clientUsers,
              [id]: {
                ...state.formDataValue.clientUsers[id],
                selected: [value]
              }
            }
          }
        }
      }

      case 'ch_selectall': {
        const { id } = action.location
        const { value } = action.payload
        let resultedArray = state.formDataValue.clientUsers[id].permissions.selected
        for (let i = 0; i < value.length; i++) {
          if (!resultedArray.includes(value[i])) {
            resultedArray = [...resultedArray, value[i]]
          }
        }
        return {
          ...state,
          formDataValue: {
            ...state.formDataValue,
            clientUsers: {
              ...state.formDataValue.clientUsers,
              [id]: {
                ...state.formDataValue.clientUsers[id],
                permissions: {
                  ...state.formDataValue.clientUsers[id].permissions,
                  selected: resultedArray
                }
              }
            }
          }
        }
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  formDataValue: {
    clientUsers: {
      0: {
        selected: [],
        textValues: {},
        permissions: {
          selected: []
        }
      }
    },
    dashboard: {}
  }
}
export default function clientUsersReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientUsers.js